export default __webpack_public_path__ + "assets/models/f0b2ae7868b8276a38939e6dd1824b66.glb";